module.exports = __webpack_public_path__ + "img/icon-discount.3b15c17b.svg";